import type { IconProps } from '@/ui/Icons/IconProps';

export const GreenLightningIcon = (props: IconProps) => (
  <svg
    className={props.className}
    height={props.height ?? 126}
    width={props.width ?? 126}
    style={props.style}
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.04" filter="url(#filter0_d_3922_78284)">
      <circle cx="63" cy="62" r="59" fill="url(#paint0_linear_3922_78284)" />
      <circle cx="63" cy="62" r="58.5" stroke="#39A150" />
    </g>
    <g opacity="0.08" filter="url(#filter1_d_3922_78284)">
      <circle cx="63" cy="62" r="47" fill="url(#paint1_linear_3922_78284)" />
      <circle cx="63" cy="62" r="46.5" stroke="#39A150" />
    </g>
    <g filter="url(#filter2_ddii_3922_78284)">
      <rect x="34" y="32" width="60" height="60" rx="30" fill="white" />
      <rect x="34" y="32" width="60" height="60" rx="30" fill="#00CB20" fillOpacity="0.06" />
      <rect x="34" y="32" width="60" height="60" rx="30" fill="url(#paint2_linear_3922_78284)" />
    </g>
    <g filter="url(#filter3_i_3922_78284)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.9794 46.5345C66.5563 46.7849 66.8991 47.3857 66.8211 48.0097L65.6034 57.7507L74.3797 57.7506C74.7211 57.7506 75.0669 57.7505 75.3494 57.7761C75.6166 57.8003 76.1283 57.8643 76.572 58.2229C77.0799 58.6334 77.371 59.2546 77.3611 59.9077C77.3525 60.4781 77.0741 60.9121 76.9216 61.1329C76.7604 61.3663 76.539 61.6319 76.3204 61.8941L63.6703 77.0742C63.2677 77.5574 62.5948 77.7173 62.0179 77.4668C61.441 77.2164 61.0983 76.6156 61.1763 75.9916L62.3939 66.2507L53.6177 66.2507C53.2762 66.2507 52.9305 66.2508 52.6479 66.2252C52.3807 66.201 51.8691 66.137 51.4254 65.7784C50.9174 65.3679 50.6264 64.7467 50.6362 64.0936C50.6448 63.5232 50.9232 63.0892 51.0757 62.8684C51.2369 62.635 51.4583 62.3694 51.677 62.1071C51.6878 62.0941 51.6986 62.0811 51.7094 62.0682L64.327 46.9271C64.7296 46.4439 65.4026 46.284 65.9794 46.5345ZM54.2733 63.4173H63.9987C64.405 63.4173 64.7918 63.5918 65.0607 63.8964C65.3296 64.2011 65.4548 64.6065 65.4044 65.0097L64.5871 71.5483L73.724 60.584H63.9987C63.5923 60.584 63.2055 60.4095 62.9366 60.1049C62.6677 59.8002 62.5425 59.3948 62.5929 58.9916L63.4103 52.453L54.2733 63.4173Z"
        fill="url(#paint3_linear_3922_78284)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3922_78284"
        x="0.756757"
        y="0.837838"
        width="124.486"
        height="124.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3922_78284" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3922_78284"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3922_78284"
        x="12.7568"
        y="12.8378"
        width="100.486"
        height="100.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3922_78284" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3922_78284"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_ddii_3922_78284"
        x="27.5714"
        y="27.7143"
        width="72.8571"
        height="72.8571"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.14286" />
        <feGaussianBlur stdDeviation="3.21429" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3922_78284" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3922_78284"
          result="effect2_dropShadow_3922_78284"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_3922_78284"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2.14286" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="shape" result="effect3_innerShadow_3922_78284" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1.08108" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          mode="normal"
          in2="effect3_innerShadow_3922_78284"
          result="effect4_innerShadow_3922_78284"
        />
      </filter>
      <filter
        id="filter3_i_3922_78284"
        x="50.636"
        y="46.4172"
        width="26.7253"
        height="31.1667"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1.41667" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3922_78284" />
      </filter>
      <linearGradient
        id="paint0_linear_3922_78284"
        x1="63"
        y1="3"
        x2="63"
        y2="121"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#59B56D" />
        <stop offset="1" stopColor="#2CA046" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3922_78284"
        x1="63"
        y1="15"
        x2="63"
        y2="109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#59B56D" />
        <stop offset="1" stopColor="#2CA046" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3922_78284"
        x1="64"
        y1="19.5"
        x2="64"
        y2="99.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009658" />
        <stop offset="1" stopColor="#00B96D" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3922_78284"
        x1="77.6676"
        y1="41.5012"
        x2="56.1804"
        y2="77.5026"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);
